<template lang="html">
			<div class="master-investments">
				<div class="group">
					<div class="flex-title">
						<div class="title">
							Performance Globale
						</div>
						<div class="title">
						Où sont mes placements ?
						</div>
					</div>
					<div class="row white-box">
						<div class="global-perfs">
							<div class="item column">
								<div class="value">
									<div class="flex items-between align-baseline">
										<div class="item-title">Montant investi : </div>
										<div class="encour">{{formatCurrency(investmentStats.amount_invested)}}</div>
									</div>
									<div class='flex items-between align-baseline'>
										<div class="item-title">Encours :</div>
										<div class="encour">{{formatCurrency(investmentStats.my_assets)}}</div>
									</div>
								</div>
							</div>
							<performance-stat
								v-for="(item, key) in globalPerfComputed"
								v-bind:key="key"
								:title="item.title"
								:value="item.value"
								:prog="item.prog"
								v-if="(key != 2) || ((key == 2) && (item.prog != 0))"
								/>
						</div>
						<mapbox
							:access-token="mapboxToken"
							:center="mapCenter"
							:zoom="1"
							style-prop="mapbox://styles/mapbox/satellite-v9"
							:markers="mapMarkers"
							:client-id="parseInt(this.$route.params.clientId ? this.$route.params.clientId : this.user.id)"
							@map-loaded="onMapLoaded"
						/>
					</div>
				</div>
				<div class="group">
					<div class="title">
						Encours & Répartition
					</div>
					<div class="ctn-several row">
						<div class="white-box with-tags with-array">
							<div class="ctn-tags row">
								<div class="tag row" v-for="(tag, key) in arrayData" v-bind:key="key" :class="{ selected: isSelected(key) }" @click="selectTag(key)">
									<div class="square" :style="{ backgroundColor: tag.color }"></div>
									<div class="label">{{ tag.name }}</div>
									<div class="value">{{ tag.valueFormatted }}</div>
								</div>
							</div>
              <div class="ctn-table ctn-section-table row">
                <section-table :columns="distributionColumnDefsFiltered" :rows="distributionRowDataFiltered" />
              </div>
						</div>
						<div class="white-box column with-tags with-stats">
							<div class="ctn-tags row">
								<div class="tag row" v-for="(tag, key) in getWithoutGlobalData(arrayData)" v-bind:key="key">
									<div class="square" :style="{ backgroundColor: tag.color }"></div>
									<div class="label">{{ tag.name }}</div>
									<div class="value">{{ tag.valueFormatted }}</div>
								</div>
							</div>
							<div class="hr"></div>
							<div class="ctn-bars row">
								<div class="bar" :style="{ width: tag.value, backgroundColor: tag.color }" v-for="(tag, key) in getWithoutGlobalData(arrayData)" v-bind:key="key">{{ tag.valueFormatted }}</div>
							</div>
              <div class="resume-stat">
                <div class="column">
									<p class="title-muted" >Encours</p>
                  <div class="ctn-values row"><div class="value">
                    {{formatCurrency(investmentStats.my_assets)}}
                  </div>
                    <div class="prog">
                      <span v-if="investmentStats.global_performance >= 0"><img :src="good" alt=""></span>
                      <span v-else><img :src="bad" alt=""></span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="column perf-mini">
                    <ul>
                      <li v-for="(distribution, key) in distributionRowDataFilteredSliced" :key="key">
                        <span class="key">{{distribution.data.name.slice(0, 5)}}</span> <span class="value" :class="{'text-green': distribution.data.perf[0] !== '-', 'text-red': distribution.data.perf[0] === '-'}">
												{{distribution.data.perf}}
											</span>
                      </li>
                    </ul>
                  </div>
                  <div class="column perf-progress-bar">
                    <progress-bar-half-circle :value="globalPerfComputed[0].prog"/>
                  </div>
                </div>
              </div>
						</div>
					</div>
				</div>
			</div>
</template>

<script>
import NotifBar from '@/common/components/notif-bar'
import Good from '@/common/assets/img/high-icon.svg'
import Bad from '@/common/assets/img/down-icon.svg'
import { mapGetters } from 'vuex'
import PerformanceStat from '@/common/components/performance-stat'
import ProgressBarHalfCircle from '@/common/components/progress-bar-half-circle'
import SectionTable from '@/common/components/section-table'
import CurrencyHelper from '@/common/utils/currency-helper'
import DjangoResource from '@/common/resources/Django'
import mapbox from '../mapbox.vue'

export default {
	components: {
		PerformanceStat,
		NotifBar,
		ProgressBarHalfCircle,
		SectionTable,
		mapbox
	},
	filters: {
		format_currency (value, symbol) {
			return value ? value.toLocaleString() + ' ' + symbol : ''
		}
	},
	props: {
		investmentStats: {
			type: null,
			default: null
		}
	},
	data () {
		return {
			good: Good,
			bad: Bad,
			hidePerformance: false,
			mapboxToken:
        'pk.eyJ1Ijoia2V2aW4tdCIsImEiOiJja2tlNHRkbmIwaGt3MnZueXc0ODhwdm1pIn0.RP7CZNTK2HeqQrpTie5uDQ',
			mapCenter: [2.3522, 48.8566],
			mapMarkers: [
				{
					lng: 2.3522,
					lat: 48.8566,
					popup: "<strong>Assurance Vie Cardif Elite</strong><br>Montant Total : 280 000€ </br><span class='text-green'>Perf : +14%</span>"
				},
				{
					lng: -74.006,
					lat: 40.7128,
					popup: "<strong>Plan Epargne Retraite Cardif Elite Retraite</strong><br>Montant Total : 36 852€ </br><span class='text-green'>Perf : +27%</span>"
				}
			],
			globalPerf: [
				{
					key: 'since_registration_perf',
					title: 'Depuis la création du compte',
					value: '0 €',
					prog: 0
				},
				{
					key: 'subscription_year_perf',
					title: 'Performance sur l’année d’abonnement en cours',
					value: '0 €',
					prog: 0
				},
				{
					key: 'sum_net_income_distributed',
					title: 'Mes revenus perçus depuis que je suis client',
					value: '0 €',
					prog: 0
				}
			],
			arrayData: [
				{
					name: 'Global',
					key: 'global',
					color: '#3F51B5'
				},
				{
					name: 'Financier',
					key: 'financial',
					color: '#FF4052',
					value: null,
					valueFormatted: null
				},
				{
					name: 'Tangible',
					key: 'tangible',
					color: '#BB9267',
					value: null,
					valueFormatted: null
				},
				{
					name: 'International',
					key: 'international',
					color: '#412B1B',
					value: null,
					valueFormatted: null
				}
			],
			arrayDataGlobal: {},
			selected: 0,
			distributionColumnDefs: null,
			distributionRowData: null,
			distributionTableOption: {
				headerHeight: 30,
				rowHeight: 50,
				localeText: {
					noRowsToShow: 'Pas de donnée pour le moment.'
				}
			}
		}
	},
	beforeMount () {
		this.distributionColumnDefs = [
			{
				name: 'Produit',
				field: 'name',
				width: 340,
				cellRenderer: this.distributionNameCellRenderer
			},
			{ name: 'Montant versé net', field: 'subscription_amount', width: 160 },
			{ name: 'Montant actuel', field: 'value', width: 140 },
			{
				name: 'Perf %',
				field: 'perf',
				width: 80,
				cellRenderer: this.distributionPerfCellRenderer
			},
			{ name: 'Poids', field: 'weight', width: 80 },
			{ name: 'Numéro de contrat', field: 'contract_number', width: 170 },
			{
				name: 'Date de souscription',
				field: 'contract_subscription_date',
				width: 170
			},
			{ name: 'Type', field: 'contract_type', width: 130 },
			{
				name: 'Revenu net distribué',
				field: 'net_income_distributed',
				width: 180
			},
			{ name: 'Parts', field: 'parts', width: 100 },

			{ name: 'Prix de la part', field: 'share_value', width: 230 }
			// {name: 'Montant versé net', field: 'net_amount_distributed', width: 230},
		]
	},
	mounted () {
		this.initializeArrayData()
		this.initializeDistributionRowData()
		this.initializeGlobalPerf()
		DjangoResource.getUserPerformance(this.$route.params.clientId ? this.$route.params.clientId : this.user.id).then(
			(data) => {
				this.globalPerf[0].prog = data.global_performance
				this.globalPerf[1].prog = data.subscription_year_perf
				this.hidePerformance = data.hide_performance
			}
		)
	},
	methods: {
		formatCurrency (number, symbol = null) {
			if (symbol) {
				return CurrencyHelper.formatCurrency(number, symbol)
			}

			return CurrencyHelper.formatCurrency(number, '€')
		},
		initializeGlobalPerf () {
			if (!this.investmentStats || Array.isArray(this.investmentStats)) {
				return
			}

			for (let index in this.globalPerf) {
				this.globalPerf[index].value = this.getCurrencyWithSymbol(
					this.investmentStats[this.globalPerf[index].key].value,
					'€'
				)
				this.globalPerf[index].prog = undefined

				if (
					this.globalPerf[index].key === 'since_registration_perf' &&
          typeof this.investmentStats['subscription_effect_date'] !==
            'undefined' &&
          this.investmentStats['subscription_effect_date']
				) {
					this.globalPerf[index].title += ` (${this.$moment(
						this.investmentStats['subscription_effect_date'],
						'DD/MM/YYYY HH:mm'
					).format('DD/MM/YYYY')})`
				}

				if (this.globalPerf[index].key === 'sum_net_income_distributed') {
					this.globalPerf[index].prog =
            this.investmentStats.sum_net_income_distributed
				}
			}
		},
		initializeDistributionRowData () {
			let rowData = []
			for (let index in this.investmentStats.distributions) {
				let info = this.investmentStats.distributions[index]
				console.log('info', info)
				let data = {
					name: info.product_name,
					parts: info.contract_part_number,
					subscription_amount: this.formatCurrency(
						info.subscription_amount,
						info.contract_part_currency
					),
					subscription_price: this.formatCurrency(
						info.contract_subscription_value,
						info.contract_part_currency
					),
					net_amount_distributed: this.formatCurrency(
						info.net_amount_distributed,
						info.contract_part_currency
					),
					share_value: this.formatCurrency(
						info.contract_part_value,
						info.contract_part_currency
					),
					value: this.formatCurrency(
						info.contract_part_value * info.contract_part_number,
						info.contract_part_currency
					),
					weight: info.contract_part_weight + '%',
					perf: this.format_performance(info.perf) + '%',
					type: info.mission_type,
					contract_type: info.contract_type,
					net_income_distributed: this.formatCurrency(
						info.net_income_distributed,
						info.contract_part_currency
					),
					contract_number: info.contract_number,
					contract_subscription_date: info.contract_subscription_date
				}
				let dataFormatted = {
					data: data,
					childrenColumn: [
						{ name: 'Support', field: 'support_name', width: 280 },
						{ name: 'ISIN', field: 'isin', width: 150 },
						{ name: 'Parts', field: 'shares', width: 100 },
						{ name: 'Date de cours', field: 'course_date', width: 150 },
						{
							name: 'Prix moyen acquis',
							field: 'average_price_acquired',
							width: 180
						},
						{ name: 'Prix de la part', field: 'share_value', width: 180 },
						{
							name: 'Épargne constituée',
							field: 'incorporated_savings',
							width: 180
						},
						{ name: 'Perf %', field: 'perf', width: 80 }
					],
					childrenRows:
            typeof info.supports !== 'undefined'
            	? info.supports.map((support) => {
            		let supportData = {
            			support_name: support.support_name,
            			shares: support.shares,
            			average_price_acquired: this.getCurrencyWithSymbol(
            				support.average_price_acquired,
            				'€'
            			),
            			incorporated_savings: this.getCurrencyWithSymbol(
            				support.incorporated_savings,
            				'€'
            			),
            			course_date: support.course_date,
            			share_value: this.getCurrencyWithSymbol(
            				support.share_value,
            				'€'
            			),
            			perf: this.format_performance(support.perf) + '%',
            			isin: support.isin
            		}

            		if (support.support_name.toLowerCase() === 'fonds general') {
            			supportData.shares = ''
            			supportData.perf = ''
            		}
            		return supportData
            	})
            	: [],
					deploy: false
				}
				rowData.push(dataFormatted)
			}

			this.distributionRowData = rowData
		},
		format_performance (value) {
			if (!value) {
				return '0'
			}

			if (value === 0) {
				return value.toLocaleString()
			}

			return value > 0 ? '+' + value.toLocaleString() : value.toLocaleString()
		},
		getCurrencyWithSymbol (value, currencyType) {
			return value ? value.toLocaleString() + ' ' + currencyType : ''
		},
		initializeArrayData () {
			this.arrayDataGlobal = this.arrayData.filter(
				(elem) => elem.name === 'Global'
			)[0]
			let arrayData = []
			arrayData.push(this.arrayDataGlobal)

			for (let index in this.investmentStats.categories) {
				let category = this.investmentStats.categories[index]
				let data = this.arrayData.find((elem) => elem.name === index)

				if (!data) {
					continue
				}

				data.value = category.percent + '%'
				data.valueFormatted = category.percent.toLocaleString() + '%'

				arrayData.push(data)
			}

			this.arrayData = arrayData
		},
		getWithoutGlobalData: function (value) {
			return value.filter((elem) => elem.name !== 'Global')
		},
		selectTag (key) {
			this.selected = key
		},
		isSelected (key) {
			return this.selected === key
		},
		distributionPerfCellRenderer (params) {
			return `<span class="${
				params.value[0] === '-' ? 'text-red' : 'text-green'
			}">${params.value}</span>`
		},
		distributionNameCellRenderer (params) {
			return `<span>${params.value}</span>`
		},
		onMapLoaded (map) {
			console.log('Mapbox loaded', map)
		}
	},
	computed: {
		...mapGetters({
			isEstate: 'isEstate',
			user: 'user'
		}),
		distributionRowDataFiltered () {
			let dataTypeSelected = this.arrayData[this.selected].name

			if (dataTypeSelected === 'Global') {
				return this.distributionRowData
			}

			return this.distributionRowData.filter(
				(element) => element.data.type === dataTypeSelected
			)
		},

		distributionRowDataFilteredSliced () {
			const data = this.distributionRowDataFiltered

			return data ? data.slice(0, 3) : data
		},

		distributionColumnDefsFiltered () {
			let dataTypeSelected = this.arrayData[this.selected].name
			if (dataTypeSelected === 'Financier') {
				return this.distributionColumnDefs.filter(
					(element) => !['parts', 'share_value'].includes(element.field)
				)
			}

			if (dataTypeSelected === 'Global') {
				return this.distributionColumnDefs.filter(
					(element) => !['parts', 'share_value'].includes(element.field)
				)
			}

			if (dataTypeSelected === 'Tangible') {
				return this.distributionColumnDefs.filter(
					(element) => !['subscription_price'].includes(element.field)
				)
			}
			return this.distributionColumnDefs
		},
		globalPerfComputed () {
			if (!this.hidePerformance) {
				return this.globalPerf
			} else {
				return [this.globalPerf[2]]
			}
		}
	}
}
</script>

<style lang="css">
.table-custom {
  padding: 20px 0 0;
}

.body-cell span {
  text-transform: uppercase;
}

.header-array {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/common/components/Investments/Synthesis.vue